import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/images/z1logo.png";
import api from "../api/axios"


const styles = {
  /* ================= TOP HEADER ================= */
  topHeader: {
    background: "#ffffff",
    borderBottom: "1px solid #eaeaea",
    padding: "12px 0",
    marginTop: "10px",
  },

  logoImg: {
    height: "120px",
    width: "120px",
  },

  trackBtn: {
    background: "#4169E1",
    color: "#fff",
    border: "none",
    padding: "10px 22px",
    borderRadius: "6px",
    fontWeight: 600,
    fontSize: "14px",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },

  topAuth: {
    display: "flex",
    alignItems: "center",
  },

  loginBtn: {
    background: "transparent",
    border: "1px solid #4169E1",
    color: "#4169E1",
    padding: "8px 16px",
    borderRadius: "20px",
    fontWeight: 500,
    cursor: "pointer",
    transition: "all 0.3s ease",
  },

  /* ================= USER DROPDOWN ================= */
  userDropdown: {
    position: "relative",
  },

  userName: {
    border: "1px solid #ddd",
    padding: "8px 16px",
    borderRadius: "20px",
    cursor: "pointer",
  },

  dropdownBox: {
    position: "absolute",
    top: "120%",
    right: 0,
    background: "#fff",
    borderRadius: "8px",
    boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
    overflow: "hidden",
    zIndex: 1000,
  },

  dropdownBtn: {
    width: "100%",
    padding: "10px 15px",
    border: "none",
    background: "transparent",
    cursor: "pointer",
    textAlign: "left",
  },

  /* ================= MAIN NAVBAR ================= */
  mainNavbar: {
    background: "#4169E1",
  },

  navContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
  },

  navLinks: {
    display: "flex",
    listStyle: "none",
    margin: 0,
    padding: 0,
  },

  navItem: {
    color: "#fff",
    padding: "14px 22px",
    cursor: "pointer",
    fontWeight: 500,
    transition: "background 0.3s ease",
  },

  menuIcon: {
    position: "absolute",
    right: 0,
    background: "none",
    border: "none",
    color: "#fff",
    fontSize: "24px",
    cursor: "pointer",
  },

  searchWrapper: {
  display: "flex",
  alignItems: "center",
  flex: 1,
  maxWidth: "600px",
  margin: "0 20px",
},

searchInput: {
  flex: 1,
  padding: "10px 14px",
  border: "1px solid #dcdcdc",
  borderRadius: "6px 0 0 6px",
  outline: "none",
  fontSize: "14px",
},

searchBtn: {
  background: "#4169E1",
  border: "none",
  color: "#fff",
  padding: "10px 16px",
  borderRadius: "0 6px 6px 0",
  cursor: "pointer",
  fontWeight: 600,
},

};

const Navbar = ({ onSidebarToggle }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showAttendanceMenu, setShowAttendanceMenu] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

 const handleLogout = () => {
  localStorage.removeItem("access");
  localStorage.removeItem("refresh");
  localStorage.removeItem("user");
  sessionStorage.clear();
  setUser(null);
  setShowDropdown(false);
  navigate("/", { replace: true });
};



  const handleNavClick = (item) => {
  if (item === "Home") {
    navigate("/");
    return;
  }

  navigate(`/#${item.toLowerCase()}`);
};

// Search Logic 
const handleSearch = () => {
  if (!searchKeyword.trim()) return;
  navigate(`/search-page?query=${encodeURIComponent(searchKeyword)}`);
};

const dropdownItemStyle = {
  padding: "10px 16px",
};

const dropdownLinkStyle = {
  textDecoration: "none",
  color: "#000",
  fontSize: "14px",
  display: "block",
};


  return (
      <>
      <style>{`
/* ================= MOBILE ================= */
@media (max-width: 768px) {
  .top-header-fix > .container {
    flex-direction: column;
    align-items: center;
    gap: 6px;
  }

  .top-header-fix img {
    height: 40px !important;
    width: 40px !important;
  }

  .top-header-fix button {
    width: 100%;
    margin: 4px 0;
  }

  /* 🔥 FIX NAV LINKS FOR MOBILE */
  .main-navbar-fix .nav-links-fix {
    display: grid;
    grid-template-columns: repeat(2, 1fr); /* 2 items per row */
    gap: 6px;
    padding: 6px;
    margin: 0;
    width: 100%;
    justify-items: center;
  }

  .main-navbar-fix .nav-links-fix li {
    width: 100%;
    text-align: center;
    padding: 10px 6px !important;
    font-size: 8px !important;
    font-weight: 600;
    white-space: normal; /* allow wrapping */
  }

  /* Dropdown alignment on mobile */
  .main-navbar-fix .nav-links-fix li ul {
    left: 50% !important;
    transform: translateX(-50%);
  }

  /* Keep hamburger hidden as requested */
  .menu-icon-fix {
    visibility: hidden;
  }
}
/* ================= TABLET ================= */
@media (min-width: 769px) and (max-width: 1024px) {
  .top-header-fix img {
    height: 100px !important;
    width: 100px !important;
  }

  .main-navbar-fix ul li {
    padding: 12px 16px !important;
  }
}

/* ================= LARGE SCREENS ================= */
@media (min-width: 1400px) {
  .top-header-fix img {
    height: 140px !important;
    width: 140px !important;
  }

  .main-navbar-fix ul li {
    padding: 18px 28px !important;
    font-size: 16px;
  }
}
`}</style>

                {/* ================= TOP HEADER ================= */}
                <div style={styles.topHeader} className="top-header-fix">
                  <div className="container d-flex align-items-center justify-content-between">

                    {/* Logo */}
                    <a href="/" style={{ textDecoration: "none" }}>
                      <img src={logo} alt="Logo" style={styles.logoImg} />
                    </a>

                    {/* SEARCH BAR (NEW) */}
                    <div style={styles.searchWrapper} className="search-bar-fix">
                      <input
                        type="text"
                        placeholder="Enter keyword to search Accessories"
                        style={styles.searchInput}
                        value={searchKeyword}
                        onChange={(e) => setSearchKeyword(e.target.value)}
                        onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                      />

                      <button style={styles.searchBtn} onClick={handleSearch}>
                        🔍
                      </button>
                    </div>
                  

                    {/* Track Service Button */}
                    <button
                      style={styles.trackBtn}
                      onMouseEnter={(e) => (e.target.style.background = "#084298")}
                      onMouseLeave={(e) => (e.target.style.background = "#0d6efd")}
                      onClick={() => navigate("/track-service")}
                    >
                      TRACK YOUR SERVICE
                    </button>
                  
                    <button
                          style={{
                            background: "transparent",
                            border: "1px solid #4169E1",
                            color: "#4169E1",
                            padding: "8px 16px",
                            borderRadius: "20px",
                            marginleft: "5px",
                            cursor: "pointer",
                            fontWeight: 500,
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.background = "#0d6efd";
                            e.target.style.color = "#fff";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.background = "transparent";
                            e.target.style.color = "#0d6efd";
                          }}
                          onClick={() => navigate("/download-page")}
                        >
                          Download
                        </button>


                    {/* Right Auth Section */}
                    <div style={styles.topAuth}>
                      {user ? (
                        <div
                          style={styles.userDropdown}
                          onMouseEnter={() => setShowDropdown(true)}
                          onMouseLeave={() => setShowDropdown(false)}
                        >
                          <span style={styles.userName}>
                            Hi {user.first_name}
                          </span>

                          {showDropdown && (
                            <div style={styles.dropdownBox}>
                              <button
                                style={styles.dropdownBtn}
                                onClick={handleLogout}
                                onMouseEnter={(e) =>
                                  (e.target.style.background = "#f5f5f5")
                                }
                                onMouseLeave={(e) =>
                                  (e.target.style.background = "transparent")
                                }
                              >
                                🚪 Logout
                              </button>
                            </div>
                          )}
                        </div>
                      ) : (
                        <button
                          style={styles.loginBtn}
                          onClick={() => navigate("/login")}
                          onMouseEnter={(e) => {
                            e.target.style.background = "#0d6efd";
                            e.target.style.color = "#fff";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.background = "transparent";
                            e.target.style.color = "#4169E1";
                          }}
                        >
                          Login
                        </button>
                      )}
                    </div>
                  </div>
                </div>

                {/* ================= NAV MENU BAR ================= */}
                <nav style={styles.mainNavbar} className="main-navbar-fix">
                  <div className="container" style={styles.navContainer}>
                      <ul style={styles.navLinks} className="nav-links-fix">
                        {["Home", "Services", "Products", "Team", "Contact"].map((item) => (
                          <li
                            key={item}
                            style={styles.navItem}
                            onMouseEnter={(e) =>
                              (e.target.style.background = "rgba(255,255,255,0.15)")
                            }
                            onMouseLeave={(e) =>
                              (e.target.style.background = "transparent")
                            }
                            onClick={() => handleNavClick(item)}
                          >
                            {item}
                          </li>
                        ))}

                        {/* GPS Tracking System */}
                        <li
                          style={styles.navItem}
                          onMouseEnter={(e) =>
                            (e.target.style.background = "rgba(255,255,255,0.15)")
                          }
                          onMouseLeave={(e) =>
                            (e.target.style.background = "transparent")
                          }
                          onClick={() => navigate("https://z1tracker.com/")}
                        >
                          GPS Tracker
                        </li>

                        {/* Attendance System (Dropdown) */}
                        <li
                          style={{ ...styles.navItem, position: "relative" }}
                          onMouseEnter={() => setShowAttendanceMenu(true)}
                          onMouseLeave={() => setShowAttendanceMenu(false)}
                        >
                          Attendance System ▾

                          {showAttendanceMenu && (
                            <ul
                              style={{
                                position: "absolute",
                                top: "100%",
                                left: 0,
                                background: "#fff",
                                listStyle: "none",
                                padding: "8px 0",
                                margin: 0,
                                minWidth: "220px",
                                borderRadius: "6px",
                                boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
                                zIndex: 999,
                              }}
                            >
                              <li style={dropdownItemStyle}>
                                <a href="/attendance/bgm-group" style={dropdownLinkStyle}>
                                  BGM Group
                                </a>
                              </li>
                              <li style={dropdownItemStyle}>
                                <a href="/attendance/redcross-group" style={dropdownLinkStyle}>
                                  Redcross Group
                                </a>
                              </li>
                              <li style={dropdownItemStyle}>
                                <a href="/attendance-system" style={dropdownLinkStyle}>
                                  Attendance System
                                </a>
                              </li>
                            </ul>
                          )}
                        </li>
                      </ul>



                    {/* Mobile Sidebar Button */}
                    <button
                      style={styles.menuIcon}
                      className="menu-icon-fix"
                      onClick={onSidebarToggle}
                    >
                      ☰
                    </button>
                  </div>
                </nav>
  </>
  );
};

export default Navbar;